import { createContext, useEffect, useState, useContext } from "react";
import { useDispatch } from "react-redux";
import axiosHttp from "../config/axios.interceptor";
import { userReducerConstant } from "../store/reducerConstant";
import { AppContext } from "./AppContext";
import { errorResponseMessage } from "../shared/const.prop";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const appContext = useContext(AppContext);

  const login = (user) => {
    setUser(user);
  };
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    dispatch({
      type: userReducerConstant.LOGOUT_SUCCESS,
    });
    setUser(null);
    navigate("../");
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (localStorage.getItem("token")) {
        try {
          const user = await axiosHttp.get(`profile`);
          login(user);
          dispatch({
            type: userReducerConstant.LOGIN_SUCCESS,
            payload: user?.data?.data || {},
          });
          // console.log("Fetched User:", user);
          if (user.status === 200) {
            if (!localStorage.getItem("zone")) {
              let firstZone = user.data.data.zone;
              localStorage.setItem("zone", firstZone[0]);
            }
          }
        } catch (e) {
          // Don't logout on 401 if we're in the middle of a Google account update
          const isGoogleAccountUpdate =
            window.location.search.includes("google=connected") ||
            sessionStorage.getItem("google_account_update_in_progress") ===
              "true";

          if (e.response?.status === 401 && isGoogleAccountUpdate) {
            // Don't logout during Google account update - let the component handle it
            console.log("Skipping logout during Google account update");
            return;
          }

          if (e.response?.status === 429) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(e),
              type: "error",
            });
            logout();
          } else if (e.response?.status === 400) {
            appContext.updateNotificationState({
              show: true,
              message: errorResponseMessage(e),
              type: "error",
            });
          } else if (e.response?.status === 401 && !isGoogleAccountUpdate) {
            // Only logout on 401 if not during Google account update
            // The axios interceptor will handle redirect
            console.log(
              "Authentication failed, interceptor will handle redirect"
            );
          } else if (e.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
          }
          //console.log(e);
        }
      }
    };
    fetchUser();
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
